import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import auth from "../../firebase.init";
import { signOut } from "firebase/auth";
import { AiOutlineUsergroupAdd, AiOutlineAppstoreAdd } from "react-icons/ai";
import { FiLogOut } from "react-icons/fi";
import { useAuthState } from "react-firebase-hooks/auth";
import LoadingSpinner from "../../Shared/LoadingSpinner";

const Dashboard = () => {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  if (!user) {
    navigate("/login");
  }

  if (loading) {
    return <LoadingSpinner></LoadingSpinner>;
  }
  return (
    <div className="drawer drawer-mobile">
      <input id="my-drawer-2" type="checkbox" className="drawer-toggle" />
      <div className="drawer-content p-10">
        {/* <!-- Page content here --> */}
        <Outlet></Outlet>
      </div>
      <div className="drawer-side border-r-2 border-indigo-500">
        <label htmlFor="my-drawer-2" className="drawer-overlay"></label>
        <ul className="menu p-4 overflow-y-auto w-full bg-base-100 text-base-content">
          {/* <!-- Sidebar content here --> */}
          <li>
            <Link to="/" className="text-lg">
              <AiOutlineUsergroupAdd className="text-2xl" /> Add Student
            </Link>
          </li>
          <li>
            <Link to="/manageStudent" className="text-lg">
              <AiOutlineAppstoreAdd className="text-2xl" />
              Manage Student
            </Link>
          </li>
          <li>
            <button className="text-lg" onClick={() => signOut(auth)}>
              <FiLogOut className="text-2xl" /> Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Dashboard;
